import { useEffect, useRef } from 'react'

import { useThree, useFrame } from '@react-three/fiber'
import { EffectComposer } from 'three/examples/jsm/postprocessing/EffectComposer'
import { RenderPass } from 'three/examples/jsm/postprocessing/RenderPass'
import { SSAARenderPass } from 'three/examples/jsm/postprocessing/SSAARenderPass'
import { SSAOPass } from 'three/examples/jsm/postprocessing/SSAOPass'

export function Postprocessing() {
  const composer = useRef()
  const { gl, size, scene, camera } = useThree()

  useEffect(() => {
    const renderPass = new RenderPass(scene, camera)

    const ssaoPass = new SSAOPass(scene, camera, size.width, size.height)
    ssaoPass.kernelRadius = 4
    ssaoPass.kernelSize = 16 // (8 to 32): 16 is a good default
    // ssaoPass.output = SSAOPass.OUTPUT.SSAO; // for tests
    ssaoPass.minDistance = 0.0001
    ssaoPass.maxDistance = 1.3

    const ssaaPass = new SSAARenderPass(scene, camera)
    ssaaPass.sampleLevel = 2 // (0 to 5): 2 = 4x SSAA

    composer.current = new EffectComposer(gl)
    composer.current.setPixelRatio(Math.min(window.devicePixelRatio, 2))
    composer.current.setSize(size.width, size.height)

    composer.current.addPass(renderPass) // input pass
    composer.current.addPass(ssaoPass) // ambient occlusion pass
    composer.current.addPass(ssaaPass) // antialiasing pass

    return () => {
      if (composer.current) {
        composer.current = null
      }
    }
  }, [scene, camera, gl, size])

  useFrame(() => {
    if (composer.current) {
      composer.current.render()
    }
  }, 1)

  return null
}
